import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const getSoilGroups = async (setData, name, page, size) => {
  return await axios.get(`soil-groups/search-page?name=${encodeURIComponent(name)}&page=${page}&size=${size}`)
    .then((response) => {
      setData(response.data.data);
    })
    .catch(() => {});
};

export default getSoilGroups;